<template>
  <div class="containerfootbj">
    <div class="containerfootbjafter" :style="{'background-color':all_app_color}">
      <div class="toptop">
        <div class="page">
          <div class="topcontentone" v-if="footercontainer.about_us">
            <div class="topcontentonetitle">{{$t('lang.About_us')}}</div>
            <p class="topcontentonetext">{{footercontainer.about_us}}</p>
          </div>
          <div
            class="topcontenttwo"
            v-if="footercontainer.address||footercontainer.phone_number||footercontainer.email||footercontainer.postal_code"
          >
            <div class="topcontenttwotitle">{{$t('lang.Contact_us')}}</div>
            <p v-if="footercontainer.address">
              <span>{{$t('lang.address')}}：</span>
              <span>{{footercontainer.address}}</span>
            </p>
            <p v-if="footercontainer.phone_number">
              <span>{{$t('lang.The_phone')}}：</span>
              <span>{{footercontainer.phone_number}}</span>
            </p>
            <p v-if="footercontainer.email">
              <span>{{$t('lang.email')}}：</span>
              <span>{{footercontainer.email}}</span>
            </p>
            <p v-if="footercontainer.postal_code">
              <span>{{$t('lang.postcode')}}：</span>
              <span>{{footercontainer.postal_code}}</span>
            </p>
          </div>
          <div class="topcontentthree maxscreen" v-if="footer_url_list&&footer_url_list.length!=0">
            <div class="topcontentthreetitle">{{$t('lang.blogroll')}}</div>
            <p style="cursor: pointer;" v-for="(item,index) in footer_url_list" :key="index">
              <a :href="item.url" target="blank">{{item.title}}</a>
            </p>
          </div>
          <div
            class="topcontentfour maxscreen width_120"
            v-if="footer_img_list&&footer_img_list.length!=0&&is_img_footer_show"
          >
            <div class="topcontentfourtitle">{{$t('lang.Social_media')}}</div>
            <div style="width:90px;height:90px;">
              <img :preview="footer_img_list[footer_img_list_index].photo"
                style="height: 100%;width:90px;"
                :src="footer_img_list[footer_img_list_index].photo"
                alt
              />
            </div>
            <div class="sjmt_bottom_block">
              <i
                class="iconfont icon-weixin"
                v-show="footer_img_list[0].title=='微信公众号'&&footer_img_list[0].photo&&footer_img_list[0].photo.length"
                @click="change_erweima_icon('weixin')"
              ></i>
              <i
                class="iconfont icon-weibo"
                v-show="footer_img_list[1].title=='官方微博'&&footer_img_list[1].photo&&footer_img_list[1].photo.length"
                @click="change_erweima_icon('weibo')"
              ></i>

              <i
                class="iconfont icon-facebook"
                v-show="footer_img_list[2].title=='facebook'&&footer_img_list[2].photo&&footer_img_list[2].photo.length"
                @click="change_erweima_icon('facebook')"
              ></i>
              <i
                class="iconfont icon-linkedIn"
                v-show="footer_img_list[3].title=='Instagram'&&footer_img_list[3].photo&&footer_img_list[3].photo.length"
                @click="change_erweima_icon('linkedIn')"
              ></i>
            </div>
          </div>
          <div class="minscreen">
            <div class="topcontentthree" v-if="footer_url_list&&footer_url_list.length!=0">
              <div class="topcontentthreetitle">{{$t('lang.blogroll')}}</div>
              <p style="cursor: pointer;" v-for="(item,index) in footer_url_list" :key="index">
                <a :href="item.url" target="blank">{{item.title}}</a>
              </p>
            </div>
            <div
              class="topcontentfour  width_120"
              v-if="footer_img_list&&footer_img_list.length!=0&&is_img_footer_show"
            >
              <div class="topcontentfourtitle">{{$t('lang.Social_media')}}</div>
              <div style="width:90px;height:90px;">
                <img :preview="footer_img_list[footer_img_list_index].photo"
                  style="height: 100%;width:90px;"
                  :src="footer_img_list[footer_img_list_index].photo"
                  alt
                />
              </div>

              <div class="sjmt_bottom_block">
                <i
                  class="iconfont icon-weixin"
                  v-show="footer_img_list[0].title=='微信公众号'&&footer_img_list[0].photo&&footer_img_list[0].photo.length"
                  @click="change_erweima_icon('weixin')"
                ></i>
                <i
                  class="iconfont icon-weibo"
                  v-show="footer_img_list[1].title=='官方微博'&&footer_img_list[1].photo&&footer_img_list[1].photo.length"
                  @click="change_erweima_icon('weibo')"
                ></i>

                <i
                  class="iconfont icon-facebook"
                  v-show="footer_img_list[2].title=='facebook'&&footer_img_list[2].photo&&footer_img_list[2].photo.length"
                  @click="change_erweima_icon('facebook')"
                ></i>
                <i
                  class="iconfont icon-linkedIn"
                  v-show="footer_img_list[3].title=='Instagram'&&footer_img_list[3].photo&&footer_img_list[3].photo.length"
                  @click="change_erweima_icon('linkedIn')"
                ></i>
              </div>
            </div>
          </div>
          <div v-show="false">{{all_app_color_comp}}</div>
          <div
            v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
            v-show="isshowxiugai"
            class="xiugai iconfont icon-xiugai"
            style="color:#ffffff;    position: absolute; right: 10px; top: 20px;"
            @click="goFooter"
          ></div>
        </div>
      </div>
      <div class="containerfootbjafter_bottom" :style="{'background-color':all_app_color}">
        <div class="bottombottom">
          <div
            class="page"
            style="font-size: 12px;justify-content: center; display:block;box-sizing:border-box;"
          >
            <div class="bottombottom_line"></div>
            <div class="bottomcontent">Copyright © {{footercontainer.support}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as serviceApi from "./api/footer";
export default {
  name: "footerr",
  data() {
    return {
      all_app_color: "#3b9dce",
      footercontainer: "",
      footer_url_list: [],
      footer_img_list: [],
      footer_img_list_index: 0,
      is_img_footer_show: false
      // icon_type:''
    };
  },
  computed: {
    all_app_color_comp() {
      if (this.$store.state.all_app_color) {
        this.all_app_color = this.$store.state.all_app_color; //将本地的全局配色，赋值给 this.all_app_color
      }
      return "";
    },
    //监听是否点击了编辑的按钮
    isshowxiugai() {
      return this.$store.state.isshowxiugai;
    },
    //监听判断是否已经管理员
    isloginADorGU() {
      return this.$store.state.role;
    }
  },
  methods: {
    change_erweima_icon(type) {
      if (type == "weixin") {
        if (
          this.footer_img_list[0].photo &&
          this.footer_img_list[0].photo.length
        ) {
          this.footer_img_list_index = 0;
        }
      } else if (type == "weibo") {
        if (
          this.footer_img_list[1].photo &&
          this.footer_img_list[1].photo.length
        ) {
          this.footer_img_list_index = 1;
        }
      } else if (type == "facebook") {
        if (
          this.footer_img_list[2].photo &&
          this.footer_img_list[2].photo.length
        ) {
          this.footer_img_list_index = 2;
        }
      } else if (type == "linkedIn") {
        if (
          this.footer_img_list[3].photo &&
          this.footer_img_list[3].photo.length
        ) {
          this.footer_img_list_index = 3;
        }
      }
      // this.icon_type=type;
    },
    //点击编辑按钮，跳转到后台
    goFooter() {
      window.open(this.GLOBAL.HT_FOOTER_);
    },
    //请求页面主要内容数据列表
    getDataList() {
      let that = this;
      serviceApi.getDataList({}).then(body => {
        that.footercontainer = body.data;
        that.footer_url_list = body.data.footer_url_list;
        that.footer_img_list = body.data.footer_social_media_list;
        if (that.footer_img_list) {
          for (let i = 0; i < that.footer_img_list.length; i++) {
            if (that.footer_img_list[i].photo&&that.footer_img_list[i].photo.length) {
              that.is_img_footer_show = true;
              that.footer_img_list_index = i;
              return;
            }
          }
        }

        that.$store.commit("changefootercontainer", that.footercontainer);
      });
    }
  },
  created() {
    if (this.$store.state.all_app_color) {
      this.all_app_color = this.$store.state.all_app_color;
    } else {
      this.all_app_color = localStorage.getItem("all_app_color"); //将本地的全局配色，赋值给 this.all_app_color
    }

    if (this.$store.state.footercontainer == "") {
      //请求页面主要内容数据列表
      this.getDataList();
    } else {
      this.footercontainer = this.$store.state.footercontainer;
      this.footer_url_list = this.footercontainer.footer_url_list;
    }
    // this.getData();
  }
};
</script>

<style scoped>
.containerfootbj .containerfootbjafter .toptop .page .width_120{
   width: 120px;
   margin-right: 20px;
}
.bottombottom_line {
  width: 100%;
  height: 1px;
  background-color: #828282;
}
.sjmt_bottom_block {
  color: #888888;
  margin-top: 7px;
  display: flex;
  align-items: center;
  width: 90px;
  /* justify-content: space-between; */
}
.sjmt_bottom_block i {
  font-size: 18px;
  /* margin-right: 2px; */
  cursor: pointer;
  margin-right: 5px;
}
.maxscreen {
  display: block;
}
.minscreen {
  display: none;
}
.xiugai {
  width: 30px;
  height: 30px;
  margin: 15px 0 0 15px;
  font-weight: 600;
  /* color: #9da5a7; */
  cursor: pointer;
}

p {
  font-size: 15px;
  margin-bottom: 10px;
  line-height: 16px;
  width: 90%;
}
.topcontentonetext {
  font-size: 15px;
  width: 90%;
  line-height: 20px;
}
.topcontentonetext,
.topcontenttwo p,
.topcontentthree p {
  color: #ffffff;
  /* color: #a9a9a9; */
}
.sjmt_bottom_block .iconfont {
  color: #ffffff;
}
.topcontentonetitle,
.topcontenttwotitle,
.topcontentthreetitle,
.topcontentfourtitle {
  font-size: 20px;
  margin-bottom: 50px;
  /* font-weight: 600; */
  margin-top: 50px;
}
.topcontentone {
  margin-left: 40px;
}

.topcontentone,
.topcontenttwo {
  display: inline-block;
  /* width: 320px; */
  width: 330px;
}
.topcontentthree,
.topcontentfour {
  display: inline-block;
  /* width: 260px; */
      width: 340px;
}
.page {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  position: relative;
}
.toptop {
  /* background: #303030; */
  background: rgba(30, 30, 30, 0.5);

  height: 100%;
  padding-bottom: 30px;
  box-sizing: border-box;
  /* opacity: 0.1; */
}
.bottombottom {
  height: 70px;
  /* background: #303030;
  opacity: 0.1; */
  background: rgba(30, 30, 30, 0.5);
}
.containerfootbj {
  height: 100%;
  /* background: #303030; */
  color: #ffffff;
  border: none;
  border-radius: 0px;
  padding: 0px;
  /* min-width: 1200px; */
}
.containerfootbjafter {
  background: #436c58;
  width: 100%;
  height: 100%;
  /* color: #ffffff; */
  /* border: none; */
  /* border-radius: 0px; */
  /* padding: 0px; */
  /* min-width: 1200px; */
}
.containerfootbjafter_bottom {
  background: #436c58;
}
.bottomcontent {
  /* height: 30px; */
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
  line-height: 30px;
  color: #ffffff;
}
.topcontent {
  height: 100%;
}
/*在992 和1199 像素之间的屏幕里，中等屏幕，分辨率低的PC*/
@media (min-width: 992px) and (max-width: 1199px) {
  .containerfootbj {
    min-width: 992px;
  }
  .page {
    min-width: 992px;
    width: 100%;
  }
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: 768px) and (max-width: 991px) {
  .containerfootbj {
    min-width: 768px;
  }
  .page {
    min-width: 768px;
    width: 100%;
  }
}
/*在480 和767 像素之间的屏幕里，超小屏幕，主要是手机*/
@media (min-width: 480px) and (max-width: 767px) {
  .topcontentonetitle,
  .topcontenttwotitle,
  .topcontentthreetitle,
  .topcontentfourtitle {
    font-size: 20px;
    margin-bottom: 25px;
    font-weight: 600;
    margin-top: 25px;
  }
  .minscreen {
    display: block;
  }
  .maxscreen {
    display: none;
  }
  .containerfootbj {
    min-width: 480px;
  }
  .page {
    min-width: 480px;
    width: 100%;
    display: block;
  }
  .topcontentone,
  .topcontenttwo,
  .minscreen {
    width: 480px;
    display: block;
    margin: 0 auto;
    padding-top: 30px;
  }
  .topcontentthree,
  .topcontentfour {
    /* width: 190px; */
        width: 250px;
    padding-bottom: 30px;
    vertical-align: middle;
  }
  .topcontentthreetitle {
    margin-top: 0px;
  }
  /* .minscreen{
    display: flex;
    justify-content: center;
  } */
  p,
  .topcontentonetext {
    font-size: 14px;
  }
  .bottomcontent {
    font-size: 12px;
  }
}
/*在小于480px的屏幕里，微小屏幕，更低分辨率的手机*/
@media (max-width: 479px) {
  .topcontentonetitle,
  .topcontenttwotitle,
  .topcontentthreetitle,
  .topcontentfourtitle {
    font-size: 20px;
    margin-bottom: 25px;
    font-weight: 600;
    margin-top: 25px;
  }
  p,
  .topcontentonetext {
    font-size: 14px;
  }
  .bottomcontent {
    font-size: 12px;
  }
  .minscreen {
    display: block;
  }
  .maxscreen {
    display: none;
  }
  .containerfootbj {
    width: 100%;
  }
  .page {
    width: 100%;
    display: block;
  }
  .topcontentone,
  .topcontenttwo,
  .minscreen {
    width: 90%;
    display: block;
    margin: 0 auto;
    padding-top: 30px;
  }
  .topcontentthree,
  .topcontentfour {
    width: 90%;
    padding-bottom: 30px;
    vertical-align: middle;
  }
  .topcontentthreetitle {
    margin-top: 0px;
  }
  .containerfootbj {
    width: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/footer/footer.vue